import React from 'react';
import formatMessage from '../../../utils/formatMessage';
import './MultiUnitTypesSummary.less';

const getMinPriceLabel = (messages, minPriceData) => {
    const label = minPriceData.isPriceRange
        ? messages.multipleUnitsFrom
        : messages.multipleUnitsPerNight;
    return (
        minPriceData.price &&
        formatMessage(label, {
            price: `<span class="MultiUnitDropdown__header_min-price-value">${
                minPriceData.price
            }</span>`
        })
    );
};

const MultiUnitTypesSummary = ({messages, propertyName, resultCount, loading, minPriceData}) => {
    return (
        <div className="MultiUnitDropdown__header micro">
            <h3 className="MultiUnitDropdown__title">{propertyName}</h3>
            {loading && (
                <div className="MultiUnitDropdown__header-row--loading">
                    <div className="MultiUnit__header-skeleton" />
                    <div className="MultiUnit__header-skeleton" />
                </div>
            )}

            {!!resultCount && resultCount > 0 && (
                <div className="MultiUnitDropdown__header_description">
                    <span
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{__html: getMinPriceLabel(messages, minPriceData)}}
                        className="MultiUnitDropdown__header_min-price-label"
                    />

                    <span className="MultiUnitDropdown__header_resultcount">
                        {formatMessage(messages.multipleUnitsTypes, {
                            count: resultCount
                        })}
                    </span>
                </div>
            )}
        </div>
    );
};

export default MultiUnitTypesSummary;
